import { Locale } from 'modules/i18n';

export const totalRequestsCardTranslation = {
  [Locale.en]: {
    title: 'Total requests',
    tooltips: {
      hour: "All users' requests for the last 1 hour",
      day: "All users' requests for the last 24 hours",
      week: "All users' requests for the last 7 days",
      month: "All users' requests for the last 30 days",
    },
    tooltipsLoggedIn: {
      hour: 'Your requests for the last 1 hour',
      day: 'Your requests for the last 24 hours',
      week: 'Your requests for the last 7 days',
      month: 'Your requests for the last 30 days',
    },
  },
};
